<template>
<section class="share-section _edit-section" v-if="pageType != 2">
    <div class="section-inner">
        <h2 class="heading-section"><span>この{{getName}}をシェアする</span></h2>
        <ul class="share-item-wrap">
            <li><a class="md_icon-btn _hover _fill"><div class="inner"><SvgIconSnsFacebook /></div></a></li>
            <li><a class="md_icon-btn _hover _fill"><div class="inner _small"><SvgIconSnsTwitter /></div></a></li>
            <li><a class="md_icon-btn _hover _fill"><div class="inner"><SvgIconSnsLine /></div></a></li>
            <li><a class="md_icon-btn _hover"><div class="inner"><SvgIconClipBoard /></div></a></li>
        </ul>
    </div><!--/.section-inner-->
</section>
<section class="share-section _preview-section">
    <div class="section-inner">
        <h2 class="heading-section"><span>この{{getName}}をシェアする</span></h2>
        <ul class="share-item-wrap" v-if="pageType==2">
            <li><a class="md_icon-btn _hover _fill" :href="`http://www.facebook.com/share.php?u=${currentUrl}`" target="_blank"><div class="inner"><SvgIconSnsFacebook /></div></a></li>
            <li><a class="md_icon-btn _hover _fill" :href="`https://twitter.com/share?url=${currentUrl}`" target="_blank"><div class="inner _small"><SvgIconSnsTwitter /></div></a></li>
            <li><a class="md_icon-btn _hover _fill" :href="`https://social-plugins.line.me/lineit/share?url=${currentUrl}`" target="_blank"><div class="inner"><SvgIconSnsLine /></div></a></li>
            <li><a class="md_icon-btn _hover" @click="copyToClipboard"><div class="inner"><SvgIconClipBoard /></div></a></li>
        </ul>
        <ul class="share-item-wrap" v-else>
            <li><a class="md_icon-btn _hover _fill"><div class="inner"><SvgIconSnsFacebook /></div></a></li>
            <li><a class="md_icon-btn _hover _fill"><div class="inner _small"><SvgIconSnsTwitter /></div></a></li>
            <li><a class="md_icon-btn _hover _fill"><div class="inner"><SvgIconSnsLine /></div></a></li>
            <li><a class="md_icon-btn _hover"><div class="inner"><SvgIconClipBoard /></div></a></li>
        </ul>
    </div><!--/.section-inner-->
</section>
</template>

<script>
    import SvgIconClipBoard from '@/components/EndUser/svg/SvgIconClipBoard'
    import SvgIconSnsFacebook from '@/components/EndUser/svg/SvgIconSnsFacebook'
    import SvgIconSnsTwitter from '@/components/EndUser/svg/SvgIconSnsTwitter'
    import SvgIconSnsInstagram from '@/components/EndUser/svg/SvgIconSnsInstagram'
    import SvgIconSnsLine from '@/components/EndUser/svg/SvgIconSnsLine'

    export default {
        components: {
            SvgIconClipBoard,
            SvgIconSnsFacebook,
            SvgIconSnsTwitter,
            SvgIconSnsInstagram,
            SvgIconSnsLine,
        },
        emits: ['openAlertModal'],
        data() {
            return {
                currentUrl: ''
            }
        },
        created() {
            this.currentUrl = window.location.href;
        },
        methods: {
            copyToClipboard() {
                navigator.clipboard.writeText(this.currentUrl)
                .then(() => {
                    this.$emit('openAlertModal', "success", 'コピーしました', 'このページのURLをクリップボードにコピーしました' ); // 確認済み
                })
                .catch(e => {
                    console.error(e)
                })
            },
        },
        computed: {
            pageType() {
                var url = location.pathname;
                if (url.indexOf( '/registration' ) != -1) {
                    //初回編集
                    return 0;
                } else if (url.indexOf( '/detail' ) != -1) {
                    //管理画面での編集
                    return 1;
                } else {
                    //エンドユーザー側での表示
                    return 2;
                }
            },
            getName() {
                var url = location.pathname;
                if (url.indexOf( '/brand' ) != -1) {
                    return 'ブランド';
                } else if (url.indexOf( '/showroom' ) != -1) {
                    return 'ショールーム';
                }
            },
        }
    }
</script>
